import React, { useEffect, useState, useContext } from "react";
import CustomHeader from "../Components/Header";
import CustomStepper from "../Components/Stepper";
import { headerTextMap } from "../Utilities/mapUtil";
import stepper, { max } from "../Utilities/stepperUtil";
import { useLocation } from "react-router-dom";
import { LanguageContext } from "../context/language/LanguageContext";
import { useDispatch, useSelector } from "react-redux";
import { guardActions } from "../store/guardSlice";
import appConst from "../Utilities/appConst.json";

const CustomAppBar = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const platform = sessionStorage.getItem(appConst.PLATFORM);

  const languageContext = useContext(LanguageContext);
  const isError = useSelector((state) => state.error.isError);
  const isBasketEmpty = useSelector((state) => state.error.isBasketEmpty);
  const marketingImages = useSelector((state) => state.user.marketingImages);
  const showHeader = useSelector((state) => state.mode.showHeader) === "true";

  const [text, setText] = useState("");
  const [showAppBar, setShowAppBar] = useState(
    !isError &&
      !isBasketEmpty &&
      (location.pathname !== appConst.FIRST_PAGE ||
        (location.pathname === appConst.FIRST_PAGE &&
          marketingImages &&
          marketingImages.length > 0))
  );

  useEffect(() => {
    if (location.pathname) {
      const titleKey = headerTextMap.get(location.pathname);
      const title = titleKey
        ? languageContext.getTranslation(titleKey) || ""
        : "";

      if (platform === appConst.PLATFORM_VAR_3) {
        lupaNativeSetTitle(title);
      } else {
        setText(title);
      }

      if (window !== window.parent) {
        const parentUrl = sessionStorage.getItem('PARENT_URL');
        const targetOrigin = parentUrl ? new URL(parentUrl).origin : '*';
        try {
          window.parent.postMessage({
            type: 'TITLE_UPDATE',
            title: title
          }, targetOrigin);
        } catch (e) {
          console.error('Failed to post title update message:', e);
        }
      }

      setShowAppBar(
        !isError &&
          !isBasketEmpty &&
          (location.pathname !== appConst.FIRST_PAGE ||
            (location.pathname === appConst.FIRST_PAGE &&
              marketingImages &&
              marketingImages.length > 0))
      );
      dispatch(guardActions.setGuardIndex(stepper.get(location.pathname)));
    }
  }, [location.pathname]);

  useEffect(() => {
    setShowAppBar(
      !isError &&
        !isBasketEmpty &&
        (location.pathname !== appConst.FIRST_PAGE ||
          (location.pathname === appConst.FIRST_PAGE &&
            marketingImages &&
            marketingImages.length > 0))
    );
  }, [isError, isBasketEmpty, marketingImages]);

  useEffect(() => {
    const syncHeaderHeightVar = () => {
      const headerElement = document.querySelector(".header");
      const headerHeight =
        showAppBar && showHeader && headerElement
          ? `${headerElement.getBoundingClientRect().height}px`
          : "0px";
      document.documentElement.style.setProperty(
        "--app-header-height",
        headerHeight
      );
    };

    syncHeaderHeightVar();
    window.addEventListener("resize", syncHeaderHeightVar);
    return () => window.removeEventListener("resize", syncHeaderHeightVar);
  }, [showAppBar, showHeader]);

  const lupaNativeSetTitle = (title) => {
    if (
      typeof window.LupaNative === "undefined" ||
      typeof window.LupaNative.setTitle !== "function"
    ) {
      return;
    }

    const safeTitle = title == null ? "" : String(title);

    try {
      window.LupaNative.setTitle(safeTitle);
    } catch (e) {
      console.error("Failed to call native setTitle:", e);
    }
  };

  return (
    <>
      {showAppBar && (
        <>
          <CustomHeader text={text}></CustomHeader>
          <CustomStepper size={max}></CustomStepper>
        </>
      )}
    </>
  );
};
export default CustomAppBar;
